import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";
import { typeLabels } from "@/mocks/videos";

interface VideoCardProps {
  video: VideoItem;
  index?: number;
}

export default function VideoCard({ video, index = 0 }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 封面`}
          title={`${video.title} ${typeLabels[video.type]} 在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />
        <span className="absolute top-2 left-2 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-label font-medium text-background-50">
          {typeLabels[video.type]}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-label font-semibold text-accent-300">
          <i className="ri-star-fill text-[10px]" />
          {video.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-2.5">
          <h3 className="truncate text-sm md:text-base font-semibold text-background-50 font-heading">
            {video.title}
          </h3>
          <p className="mt-0.5 truncate text-xs text-background-200">
            {video.region} · {video.year}
          </p>
        </div>
      </div>
      <p className="mt-2 line-clamp-2 text-xs md:text-sm leading-relaxed text-foreground-600">
        {video.summary}
      </p>
    </Link>
  );
}